import { Component, inject, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '../layout.service';
import { LanguageSwitcherComponent } from '../../shared/language-switcher/language-switcher.component';
import { LayoutConfiguratorComponent } from '../configurator/layout-configurator.component';
import Keycloak from 'keycloak-js';
import { NotificationComponent } from './notification/notification.component';

@Component({
  selector: 'sm-layout-topbar',
  standalone: true,
  imports: [RouterModule, CommonModule, StyleClassModule, LanguageSwitcherComponent, LayoutConfiguratorComponent, NotificationComponent],
  templateUrl: `./layout-topbar.component.html`,
})
export class LayoutTopbarComponent implements OnInit {
  items!: MenuItem[];

  layoutService = inject(LayoutService);
  private keycloak = inject(Keycloak);

  fullName = '';

  ngOnInit(): void {
    this.loadUserFullName();
  }

  loadUserFullName(): void {
    const tokenParsed = this.keycloak.tokenParsed;

    if (tokenParsed) {
      const firstName = (tokenParsed as any).first_name || '';
      const lastName = (tokenParsed as any).last_name || '';
      this.fullName = `${firstName} ${lastName}`.trim();
    }
  }

  toggleDarkMode() {
    this.layoutService.layoutConfig.update(state => ({
      ...state,
      darkTheme: !state.darkTheme,
    }));
  }

  toggleMobileMenu() {
    this.layoutService.layoutState.update(prev => ({
      ...prev,
      staticMenuMobileActive: !prev.staticMenuMobileActive,
    }));
  }

  logout() {
    this.keycloak.logout();
  }
}
